import React, {
    useState,
    useEffect
} from 'react'
import Image from "./umap.png"

import JSONDATA from './genes.json';
import {
  createColumnHelper,
  flexRender,
  getCoreRowModel,
  useReactTable,
} from '@tanstack/react-table'
export default function SnRNA() {
    const [body, setBody] = React.useState(null);
    const [headers, setHeaders] = React.useState(null);
    const [loading, setLoading] = useState(true);
    const handleGeneData = (data) => {
        let listItems = data.header.map((head, index) =>
            <th key={index}>{head}</th>
        )
        let bodyItems = data.data.map((rowContent, rowId) =>
            <tr key={rowId}>{rowContent.map((col, colId) =>
                <td key={colId} >{col}</td>
            )}
            </tr>
        )
        setHeaders(listItems)
        setBody(bodyItems)
    }
    const fetchGene = (name) => {
        {
            JSONDATA.filter((val) => {
                if (val.name.toLowerCase() === name.toLowerCase()) {
                    fetch("https://s3.us-east-2.amazonaws.com/ksusztak.genemap/KK/" + val.uuid + ".json")
                        .then(response => response.json())
                        .then(data => handleGeneData(data))
                } else {
                    setHeaders(null)
                }
            })
        }
    }
    return (
        <div>
            <div>

            <div>
                <input type="text" placeholder="search..."
                    onChange={
                        e => fetchGene(e.target.value)
                    }
                />
            </div>
	                    <img
                    src={Image}
                    width={900} height={600}
                    alt="umap"
                />

                            <div>
                {headers && body ? (
                    <table style={{ width: 500 }}>
                        <thead><tr>{headers}</tr></thead>
                        <tbody>{body}</tbody>
                    </table>

                ) : (
                    <div>
                    </div>
                )}
            </div>
     <br></br>
            </div>
            <div className="bottom-component">
	    Single nuclei gene expression in a Multi-Species Integrated Single-Cell Kidney Atlas
(SISKA 1.0). Gene expression is shown for human data. Log and normalized
average expression was calculated across all samples (Average Expression (All
Samples)), across just control samples Average Expression (Control Samples), and
across just diseased samples Average Expression (Disease Samples). We also
display the fraction of cells that had counts of given gene across all samples, Fraction
Expressing (All Samples), the fraction of cells with counts within just control
samples Fraction Expressing (Control Samples), and just in diseased
samples Fraction Expressing (Disease Samples). We also calculate p-values to see if
each gene expression is differentially expressed for each cell type CellType marker p-
values, and a p-value for differentially expressed in disease samples as compared to
control samples Disease control p-values. P-values were calculated using a Wilcoxon
rank-sum test and were corrected for multiple testing using the Benjamini-Hochberg
method. This was performed using scanpy&#39;s rank_genes_groups function. P-values less
than 1x10-310 are reported as 0.
            </div>
        </div>
    );
}
